export default {
  page: () => import("/var/www/vhosts/kedian.de/httpdocs/frontend/layouts/page.vue").then(m => m.default || m)
}